import Swiper from 'swiper/swiper-bundle.mjs';

window.swiper = window.Swiper = Swiper;

// Measure the real scrollbar width and expose it as --nss-scrollbar-gutter so
// fixed/sticky elements can offset for it precisely (CSS holds a close fallback).
const setScrollbarGutter = () => {
  const docEl = document.documentElement;
  const scrollbarWidth = window.innerWidth - docEl.clientWidth;
  docEl.style.setProperty(`--nss-scrollbar-gutter`, `${scrollbarWidth}px`);
};
setScrollbarGutter();
window.addEventListener(`resize`, setScrollbarGutter);
